import script from "./UnavailableGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./UnavailableGroup.vue?vue&type=script&setup=true&lang=js"

import "./UnavailableGroup.vue?vue&type=style&index=0&id=169d58b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169d58b0"]])

export default __exports__